import { BaseDDConfig, configure } from '@prenuvo/nimbus-logger';

export const getLogger = (name: string, baseConfigObj: BaseDDConfig) => {
  const logLevel = baseConfigObj.env === 'loc' ? 'debug' : 'info';

  return configure(name, logLevel, baseConfigObj);
};
